module.exports = __webpack_public_path__ + "img/statice.e94028cf.jpg";